export default "__VITE_ASSET__D2abR76Z__"